<template>
    <div v-scroll="onScroll" id="root">
        <div id="container">
            <div @contextmenu.prevent id="backgroundContainer">
                <div id="caption"><h1>Julio</h1></div>
                <div id="captionSecondary"><span>Intuitively ambiguous.</span></div>
                <div :style="phoneScale" class="imageBackground">
                    <img src="../assets/phone_mock_up_shadow.png">
                </div>
                <div :style="cardsScale" class="cards">
                    <img src="../assets/cards.png">
                </div>

                <div :style="phoneScale" class="imageBackground">
                    <img src="../assets/phone_mock_up_front.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "CardParallaxLarge",
		props: {
			initialOffset: {
				type: Number,
				default: 1,
			}
		},
		methods: {
			onScroll() {
				this.offsetTop = window.scrollY
			}
		},
		computed: {
			phoneScale() {
				let scaleFactor = 600 / (this.offsetTop / 2.2)
				if (this.offsetTop > 0)
					return `transform: scale(${scaleFactor})`
				return `transform: scale(0)`
			},
			cardsScale() {
				let scaleFactor = 100 / (this.offsetTop / 15)
				let translateFactor = -80 + (this.offsetTop * 0.001)
				return {
					transform: `scale(${scaleFactor}) translateX(${translateFactor}em)`
				}
			}
		},
		data() {
			return {
				offsetTop: this.initialOffset
			}
		}
	};
</script>

<style lang="scss" src="../styles/cardparallaxlarge.scss" scoped></style>